import { render, staticRenderFns } from "./farmLegend.vue?vue&type=template&id=fdb954ee&scoped=true"
import script from "./farmLegend.vue?vue&type=script&lang=js"
export * from "./farmLegend.vue?vue&type=script&lang=js"
import style0 from "./farmLegend.vue?vue&type=style&index=0&id=fdb954ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb954ee",
  null
  
)

export default component.exports